import WebFooter from "./web";
import MobileFooter from "./mobile";

export default function Footer({isMobile,setShowHelp}) {
    return isMobile ? <MobileFooter setShowHelp={setShowHelp} /> : <WebFooter setShowHelp={setShowHelp}/>;
}